import * as focusTrap from "focus-trap";

class ElmModal extends HTMLElement {
  connectedCallback() {
    this.previousActiveElement = document.activeElement;
    this.trap = focusTrap.createFocusTrap(this);
    this.trap.activate();
  }

  disconnectedCallback() {
    this.trap.deactivate();
    this.trap = undefined;
    this.previousActiveElement.focus();
    this.previousActiveElement = undefined;
  }
}

customElements.define("elm-modal", ElmModal);
